/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_comment = {
    readonly id: string;
    readonly localReplies: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment">;
    }> | null;
    readonly " $refType": "LocalReplyListContainer_comment";
};
export type LocalReplyListContainer_comment$data = LocalReplyListContainer_comment;
export type LocalReplyListContainer_comment$key = {
    readonly " $data"?: LocalReplyListContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "LocalReplyListContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "localReplies",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ReplyListCommentContainer_comment"
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'd06c9ecad84de10e1f6ec476384ec16c';
export default node;
